import layoutHeaderAside from '@/layout'

import f_preOrder from './modules/factory/preOrder'
import f_order from './modules/factory/order'
import f_technology from './modules/factory/technology'
import f_plan from './modules/factory/plan'
import f_purchase from './modules/factory/purchase'
import f_transport from './modules/factory/transport'
import f_tc from './modules/factory/tc'
import f_production from './modules/factory/production'
import f_inventory from './modules/factory/inventory'
import f_inspection from './modules/factory/inspection'
import f_quality from './modules/factory/quality'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/',
    component: layoutHeaderAside,
    children: [
      // 首页
      {
        path: '/',
        alias: '/digitalFactory',
        name: 'index',
        meta: {
          auth: true,
          funcID: 'F00',
          PID: 'F00',
          head: true,
          title: '首页',
        },
        component: _import('factory'),
      },
      {
        path: '/403',
        name: '403',
        meta:{
          title: '无权限访问'
        },
        component: _import('system/403')
      },
    ],
  },
  f_preOrder,
  f_order,
  f_technology,
  f_plan,
  f_purchase,
  f_transport,
  f_tc,
  f_production,
  f_inventory,
  f_inspection,
  f_quality,
]

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    meta: {
      funcID: 'LOGIN',
    },
    component: _import('system/login'),
  },
  {
    path: '/opview/order/expense/:code',
    name: `opview-order-expense`,
    meta: {
      auth: false,
      title: '订单费用单详情',
    },
    component: _import('factory/h5View/orderExpense'),
  },
  {
    path: '/opview/tc/expense/:code',
    name: `opview-tc-expense`,
    meta: {
      auth: false,
      title: 'TC采购请款单详情',
    },
    component: _import('factory/h5View/tcExpense'),
  },
  {
    path: '/opview/shipment/expense/:code',
    name: `opview-shipment-expense`,
    meta: {
      auth: false,
      title: '发运单费用单详情',
    },
    component: _import('factory/h5View/shipmentExpense'),
  },
  {
    path: '/opview/order/deduction/:code',
    name: `opview-order-deduction-expense`,
    meta: {
      auth: false,
      title: '订单扣款填报单详情',
    },
    component: _import('factory/h5View/orderDeduction'),
  },
  {
    path: '/opview/fabricInspectionReport/:code',
    name: `opview-fabric-inspection-report`,
    meta: {
      auth: false,
      title: '面料检验报告详情',
    },
    component: _import('factory/h5View/fabricInspectionReport'),
  },
  {
    path: '/opview/quality/iqcInspectionReviewDetail/:code',
    name: `opview-quality-iqcInspectionReviewDetail`,
    meta: {
      auth: false,
      title: '辅料检验审批',
    },
    component: _import('factory/h5View/iqcInspectionReview'),
  },
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
  ...frameIn,
  ...frameOut,
  // ...errorPage
]
